import React, { useState, useEffect } from "react";
import styles from "./NameAndDescription.module.sass";
import TooltipGlodal from "../../../components/TooltipGlodal";

// Screens
import StudentInformations from "./StudentInformations";
import AddressInformations from "./AddressInformations";
import StudyInformations from "./StudyInformations";
import OtherInformations from "./OtherInformations";
import LegalGuardianInformations from "./LegalGuardianInformations";
import AddressLegalGuardianInformations from "./AddressLegalGuardianInformations";

// Services
import { updateStudent } from "../../../services/student.service";
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ student: initialStudent }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [studentData, setStudentData] = useState({});
  const [isMinor, setIsMinor] = useState(false);

  // Initialiser les données de l'étudiant lorsque les props changent
  useEffect(() => {
    if (initialStudent) {
      setStudentData(initialStudent);

      // Vérifier si l'étudiant est mineur
      if (initialStudent.birth_date) {
        const birthDate = new Date(initialStudent.birth_date);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setIsMinor(age < 18);
      }
    }
  }, [initialStudent]);

  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (name === "birth_date") {
      if (value) {
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setIsMinor(age < 18);
      } else {
        setIsMinor(false);
      }
    }
  };

  const handleSwitchChange = (name, value) => {
    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Utiliser updateStudent au lieu de createStudent
      await updateStudent(studentData.id, studentData);
      showSuccess("Élève mis à jour avec succès!");
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour l'élève: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <StudentInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onDropdownChange={handleDropdownChange}
            />
            <AddressInformations
              student={studentData}
              onStudentChange={handleStudentChange}
            />
            {isMinor && (
              <>
                <LegalGuardianInformations
                  student={studentData}
                  onStudentChange={handleStudentChange}
                  onDropdownChange={handleDropdownChange}
                />
                <AddressLegalGuardianInformations
                  student={studentData}
                  onStudentChange={handleStudentChange}
                />
              </>
            )}
            <OtherInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
            <StudyInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
              loading={loading}
            />

          </form>
        </div>
      </div>
      <TooltipGlodal />
    </>
  );
};

export default NameAndDescription;
